import React from "react";

export default function Footer() {
    return (
        <footer className="mt-24 bg-tmc-black text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3">
                        <span className="tmc-logo-mark w-12 h-12" style={{ background: "transparent", padding: 0 }}>
                            <img src="/tmc-logo.png" alt="TMC" className="w-full h-full object-contain" />
                        </span>
                        <div>
                            <div className="font-serif text-2xl">Moments That Move Us</div>
                            <div className="label-overline text-white/50 mt-1">Physical, Occupational & Speech Therapy</div>
                        </div>
                    </div>
                    <p className="text-sm text-white/70 mt-5 max-w-md leading-relaxed">
                        A small ritual of gratitude, told in the voices of those who care every day.
                    </p>
                </div>
                <div className="md:text-right text-sm text-white/60">
                    <div className="label-overline text-white/40 mb-2">Therapy Management Corporation</div>
                    <div>© {new Date().getFullYear()} TMC.</div>
                    <div className="mt-1">Stories shared with care.</div>
                </div>
            </div>
            <div className="h-1 w-full" style={{ background: "linear-gradient(90deg, #FFB72E 0%, #FFB72E 25%, #FF7A59 25%, #FF7A59 50%, #5FBA47 50%, #5FBA47 75%, #3FA9E0 75%, #3FA9E0 100%)" }} />
        </footer>
    );
}
